var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.594,
    height: 57.593,
    viewBox: "0 0 57.594 57.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M39.334,78.31A47.969,47.969,0,0,1,.184,39.047a14.158,14.158,0,0,1,.144-5.311c.736-3.378,2.692-6.614,5.975-9.9l1.353-1.352a5.406,5.406,0,0,1,7.636,0l8.145,8.145a5.4,5.4,0,0,1,0,7.636l-3.078,3.078c-4.5,4.5-4.181,6.528-3.171,8.053C18.388,51.205,27.3,60.114,29.1,61.313c1.527,1.01,3.559,1.327,8.055-3.171L40.6,55.064a5.406,5.406,0,0,1,7.636,0l7.781,8.146a5.4,5.4,0,0,1,0,7.636L54.665,72.2c-3.285,3.285-6.523,5.238-9.9,5.975a14.017,14.017,0,0,1-3.02.328,15.865,15.865,0,0,1-2.412-.19",
    transform: "translate(0 -20.907)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.d41a702171477bbad303cc95c7f6c193.svg";
export { ForwardRef as ReactComponent };